import { render, staticRenderFns } from "./LatestNews.vue?vue&type=template&id=5351bdef"
import script from "./LatestNews.vue?vue&type=script&lang=js"
export * from "./LatestNews.vue?vue&type=script&lang=js"
import style0 from "./LatestNews.vue?vue&type=style&index=0&id=5351bdef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports